import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const MobileIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 1L8 1C6.34 1 5 2.34 5 4L5 20C5 21.66 6.34 23 8 23L16 23C17.66 23 19 21.66 19 20L19 4C19 2.34 17.66 1 16 1ZM17 18L7 18L7 4L17 4L17 18ZM14 21L10 21L10 20L14 20L14 21Z"
      fill="currentColor"
    />
  </svg>
);

MobileIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(MobileIcon);
